import { render, staticRenderFns } from "./VulnerabilitySeverity.vue?vue&type=template&id=a7722c6a"
import script from "./VulnerabilitySeverity.vue?vue&type=script&setup=true&lang=ts"
export * from "./VulnerabilitySeverity.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports